import { MonthHeader as MonthHeader$2, BlankCell, DayNameCell } from './style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var dayTexts = {
  1: ['MÅ', 'TI', 'ON', 'TO', 'FR', 'LÖ', 'SÖ'],
  3: ['MA', 'TI', 'ON', 'TO', 'FR', 'LØ', 'SØ'],
  11: ['MA', 'TI', 'ON', 'TO', 'FR', 'LØ', 'SØ'],
  15: ['MA', 'TI', 'KE', 'TO', 'PE', 'LA', 'SU'],
  18: ['MÅ', 'TI', 'ON', 'TO', 'FR', 'LÖ', 'SÖ']
};
var MonthHeader = function MonthHeader(_ref) {
  var siteId = _ref.siteId,
    className = _ref.className;
  var days = dayTexts[siteId];
  return /*#__PURE__*/jsxs(MonthHeader$2, {
    className: className,
    children: [/*#__PURE__*/jsx(BlankCell, {}), days.map(function (day) {
      return /*#__PURE__*/jsx(DayNameCell, {
        children: day
      }, "day-".concat(day));
    })]
  });
};
MonthHeader.defaultProps = {
  siteId: 1,
  className: ''
};
var MonthHeader$1 = MonthHeader;

export { MonthHeader$1 as default };
//# sourceMappingURL=MonthHeader.js.map
